/**
 * Re-exports from the unified permissions utility.
 *
 * PermissionsModal, PermissionsGate, and TrackingBootstrap load the
 * permission list at runtime via loadAllRequiredPermissions (the SDK
 * call inside it is async).
 */
export type { PermissionItem } from "@utils/permissions";
export {
  BATTERY_KEY,
  BATTERY_REQUESTED_KEY,
  POST_NOTIFICATIONS,
  loadAllRequiredPermissions,
  loadRequiredPermissionKeys,
  requiredByApp,
} from "@utils/permissions";
